module.exports = __webpack_public_path__ + "img/sunset.76a957c6.svg";